import { CardNumberElement, CardNumberElementProps, ICardNumberElement } from '@basis-theory/react-elements'
import React, { forwardRef } from 'react'
import { styles } from './payment-form'

interface CardNumberInputProps {
  id: string
  placeholder: string
  onChange: CardNumberElementProps['onChange']
}

const CardNumberInput = forwardRef<ICardNumberElement, CardNumberInputProps>(({ id, placeholder, onChange }, ref) => (
  <div className="w-full rounded-md border border-input bg-transparent shadow-sm transition-colors focus-within:ring-1 focus-within:ring-ring px-2">
    <CardNumberElement id={id} ref={ref} style={styles} placeholder={placeholder} onChange={onChange} />
  </div>
))

export default CardNumberInput
